<template>
    <div style="margin: 0 20px;">
        <div id="commentList">
                <!-- <div>
                    <CommentTextarea :resultItem="resultItem" @toAdd="toAdd">
                    </CommentTextarea>
                </div> -->
                <div style="margin-top: 20px;" v-if="commentData">
                    <div class="comment-box" v-for="(item, index) in commentData.comment">
                        <div class="dflex">
                            <div>

                                <img :src="item.clientPhoto || emptyAvatar" mode="aspectFill" class="avatar" />
                            </div>
                            <div class="comment-main">
                                <!-- 父评论体-start -->
                                <div>
                                    <div class="comment-main-top">
                                        <div class="nick-name-box">

                                            <div class="nick-name">{{ item.clientName }}</div>
                                        </div>

                                    </div>
                                    <div class="comment-main-content">
                                        {{ item.comment.length > 60 ? item.comment.slice(0, 59) : item.comment }}
                                        <span v-if="item.comment.length > 60">
                                            {{ item.hasShowMore ? item.comment.slice(59) : '...' }}
                                            <span class="foot-btn" @click="showMore(item.articleCommentId)">
                                                {{ item.hasShowMore ? '收起' : '展开' }}
                                            </span>
                                        </span>

                                    </div>
                                    <div class="comment-main-foot">

                                        <div class="foot-time">{{ item.time }}</div>
                                        <div class="foot-btn"
                                            @click="reply(item.clientName, item.clientName, item.articleCommentId)">
                                            {{ item.replayFlagF ? '收起' : '回复' }}</div>
                                        <div class="foot-btn" v-if="item.owner"
                                            @click="confirmDelete(item.articleCommentId)">
                                            删除
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top: 5px;">
                                    <CommentTextarea v-if="item.replayFlagF" :resultItem="item" :pId="item.articleCommentId"
                                        @toAdd="toAdd">
                                    </CommentTextarea>
                                </div>
                                <!-- 父评论体-end -->
                                <!-- 子评论列表-start -->
                                <div class="comment-sub-box">
                                    <div class="dflex" v-for="each in item.showMoreList">
                                        <div>
                                            <image :src="each.clientPhoto || emptyAvatar" mode="aspectFill" class="avatar">
                                            </image>
                                        </div>
                                        <div class="comment-main">
                                            <div class="sub-comment-main-top">
                                                <div class="nick-name">{{ each.clientName }}</div>

                                            </div>
                                            <div class="comment-main-content">
                                                {{ each.comment > 60 ? each.comment.slice(0, 59) : each.comment }}
                                                <span v-if="each.comment.length > 60">
                                                    {{ each.hasShowMore ? each.comment.slice(59) : '...' }}
                                                    <span class="foot-btn" @click="showMore(each.articleCommentId)">
                                                        {{ each.hasShowMore ? '收起' : '展开' }}
                                                    </span>
                                                </span>

                                            </div>
                                            <div class="comment-main-foot" style="padding-bottom: 20rpx;">
                                                <div class="foot-time">{{ each.time }}</div>

                                                <div class="foot-btn" v-if="each.owner"
                                                    @click="confirmDelete(each.articleCommentId)">删除
                                                </div>
                                            </div>
                                            <div>
                                                <CommentTextarea v-if="each.replayFlagF" :resultItem="each">
                                                </CommentTextarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>


                                    <div v-if="item.replyComments && item.replyComments.length > 3">

                                        <a-button size="small" class="expandButton"
                                            @click="toShowMoreReply(item.articleCommentId)"
                                            style="background-color: #e7e7e7;color: black;opacity: 0.7;border:0px !important">{{
                                                item.toShowMore ? '收起' : '展开' }}剩余回复</a-button>
                                    </div>
                                </div>
                                <!-- 子评论列表-end -->
                                <div class=" comment-box-split">
                                </div>

                            </div>

                        </div>

                    </div>
                    <div v-if="pagination && commentData && commentData.comment && pagination.total == commentData.comment.length"
                        class="dflex" style="color: #909399;justify-content: center; align-items: center;margin-top:10px">
                        <div class="split"></div> THE END <div class="split"></div>
                    </div>
                    <div v-else style="text-align: center;margin-top: 10px;">
                        <a @click="toShow()">展开更多评论</a>
                    </div>
                </div>
            </div>
        <a-modal centered width="20%" title="" v-model:visible="deleteVisible" :afterClose="afterClose" :closable="false"
            :footer="null">
            <div style="text-align: center;">
                <p>确定删除此评论？</p>
                <div>
                    <a-button @click="toDelete" :loading="confrimLoading" style="margin-right: 30px;"
                        type="primary">确认</a-button>
                    <a-button @click="afterClose">取消</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script setup>
import { getTreeItem } from "./untils"
import { getCommentPage, postComment, getDeleteComment } from './js'
import store from '@/store';
import CommentTextarea from './CommentTextarea.vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import { watch, ref, defineEmits, defineProps, reactive, nextTick } from 'vue';
import { message } from "ant-design-vue";

const visible = ref(false)
const showProps = defineProps(['showVisible', 'articleId', 'commentData', 'pagination'])
const showEmits = defineEmits('closeComment', 'toGetCommentPage')
const scrollView = ref()
watch(() => showProps.showVisible, async (val) => {

    afterClose()
    if (val == true)
        await store.dispatch("avatar").then(() => {

            resultItem.value = { src: store.getters.avatar, replayFlag: true }
            console.log(showProps.commentData, '    visible.value = val')
            title.value = '共' + (showProps.pagination ? showProps.pagination.total : '0') + '条评论'
            commentData.value = showProps.commentData
            visible.value = true
            pagination.current = showProps.pagination.current
            pagination.total = showProps.pagination.total



        })
    else visible.value = false

})

watch(() => showProps.commentData, async (val) => {
    commentData.value = {}
    if (val)
        await store.dispatch("avatar").then(() => {
            resultItem.value = { src: store.getters.avatar, replayFlag: true }
            title.value = '共' + (showProps.pagination ? showProps.pagination.total : '0') + '条评论'
            commentData.value = showProps.commentData
            pagination.current = showProps.pagination.current
            pagination.total = showProps.pagination.total
        })


})
const title = ref('')
const emptyAvatar = ref('https://enplus.oss-cn-guangzhou.aliyuncs.com/file/4d57c99d-ca12-4aec-bdfd-645d2b45c86d.png')
const onClose = () => {
    showEmits('closeComment')
    visible.value = false
}
const commentData = ref(null)
const pagination = reactive({
    current: 1,
    size: 10,
    total: 0
})
const toShow = async () => {
    console.log(pagination.total, commentData.value, visible, 'toShow')

    if (pagination.total > commentData.value.comment.length) {
        pagination.current = pagination.current + 1
        await store.dispatch("clientId").then(() => {
            getCommentPage(
                {
                    article: showProps.articleId,
                    company: store.getters.company.companyId,
                    current: pagination.current,
                    size: pagination.size,
                }
            ).then(async (res) => {

                for (var i in res.data.records) {
                    res.data.records[i] = getTreeItem(res.data.records[i], true)
                    if (res.data.records[i].replyComments) {
                        for (var j in res.data.records[i].replyComments)
                            res.data.records[i].replyComments[j] = getTreeItem(res.data.records[i].replyComments[j])
                        if (res.data.records[i].replyComments.length > 3) {
                            res.data.records[i]['noShowMoreList'] = res.data.records[i].replyComments.slice(0, 3)
                            res.data.records[i]['showMoreList'] = res.data.records[i]['noShowMoreList']
                        }
                        else {
                            res.data.records[i]['noShowMoreList'] = res.data.records[i].replyComments
                            res.data.records[i]['showMoreList'] = res.data.records[i].replyComments
                        }

                    }

                }
                var comment = res.data.records

                comment = [...commentData.value.comment, ...comment];

                commentData.value = {

                    comment: comment,
                }




            })
        })
    }





}



//展开剩余回复回复
const toShowMoreReply = (articleCommentId) => {
    var result = commentData.value.comment.find(item => item.articleCommentId == articleCommentId)
    if (result.toShowMore == false)
        commentData.value.comment.find(item => item.articleCommentId == articleCommentId).showMoreList = result.replyComments
    else commentData.value.comment.find(item => item.articleCommentId == articleCommentId).showMoreList = result.noShowMoreList


    commentData.value.comment.find(item => item.articleCommentId == articleCommentId).toShowMore = !result.toShowMore


}
const showMore = (commentId) => {
    for (var i in commentData.value.comment) {

        if (commentData.value.comment[i].articleCommentId == commentId) {
            commentData.value.comment[i].hasShowMore = !commentData.value.comment[i].hasShowMore;


        }
        if (commentData.value.comment[i].replyComments) {
            for (var j in commentData.value.comment[i].showMoreList) {

                if (commentData.value.comment[i].showMoreList[j].articleCommentId == commentId) {
                    commentData.value.comment[i].showMoreList[j].hasShowMore = !commentData.value.comment[i].showMoreList[j].hasShowMore;


                }
            }
        }


    }
}
const resultItem = ref()
const reply = (pUser, reUser, pId) => {


    for (var i in commentData.value.comment) {
        if (commentData.value.comment[i].articleCommentId == pId) {
            commentData.value.comment[i].replayFlagF = !commentData.value.comment[i].replayFlagF;


        }
        else commentData.value.comment[i].replayFlagF = false

    }

    console.log(commentData.value.comment, 'commentData.value.comment')


}
const deleteVisible = ref(false)
const confirmDelete = (value) => {
    deleteVisible.value = true
    deleteId.value = value

}
const afterClose = () => {
    deleteVisible.value = false
}

const toAdd = (req) => {

    if (confrimLoading.value == false) {
        postComment({
            "article": showProps.articleId,
            "articleComment": req.pId,
            "comment": req.content,
            "company": store.getters.company.companyId
        }).then((res) => {
            if (res.msg == '处理成功') {

                message.success('评论成功!')
    //             if (req.pId) {
                  
    //                 const firstCommentBox = document.querySelector('.comment-box');
    //   if (firstCommentBox) {
    //     const targetDiv = document.getElementById('container');
    //     const offset = 10; // 偏移量
    //     alert(firstCommentBox.getBoundingClientRect().top +targetDiv.clientHeight)
    //     const topPosition = firstCommentBox.getBoundingClientRect().top +targetDiv.clientHeight - offset;
    //     alert(topPosition)
    //     targetDiv.scrollTo({ top: topPosition, behavior: 'smooth' });
    //   }
    //             }

                showEmits('toGetCommentPage', true)
            }
            else message.warning('评论失败！')
            confrimLoading.value = false
        }).catch(() => {
            confrimLoading.value = false
        })
    }


}
const deleteId = ref()
const confrimLoading = ref(false)
const toDelete = () => {
    if (confrimLoading.value == false) {
        confrimLoading.value = true
        getDeleteComment({ articleComment: deleteId.value }).then(async (res) => {
            if (res.msg == '处理成功') {
                deleteVisible.value = false
                message.success('删除成功！')
                const element = document.getElementById("commentList");
                console.log(element, 'element')
                element.scrollIntoView();
                showEmits('toGetCommentPage')


            }
            else message.warning('删除失败!')
            confrimLoading.value = false
        }).catch(() => {
            confrimLoading.value = false
        })
    }
}


</script>
<style scoped>
.expandButton:hover,
.expandButton:focus {
    font-weight: 700;
}

.comment-box {
    padding: 0px 0;
}

.comment-box-split {
    height: 1px;
    width: 100%;
    background-color: #e9eaec;
    margin-top: 10px;
}

.split {
    border-bottom: 1px solid #e4e7ed;
    width: 75px;
    margin: 0px 5px;
}

.comment-main {
    padding-left: 2px;
    width: 100%;
    word-break: break-all;
}

.comment-main-top {

    padding-top: 10px;
    display: flex;
    justify-content: space-between;
}

.nick-name-box {
    display: flex;
    align-items: center;
}

.nick-name {
    color: #2d8cf0;
}

.comment-main-content {
    padding: 2px 2px 2px 0;
}

.comment-main-foot {
    display: flex;
    font-size:12px;
    color: gray;
}


.comment-sub-box {
    padding: 5px 0;
}




.foot-btn {
    padding-left: 20px;
    color: #007AFF;
    cursor: pointer;
}

.close {
    cursor: pointer;
}



.avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
}

.dflex {
    display: flex !important;
}
</style>